import React, { Component } from 'react';
import { connect } from 'react-redux';

import { SearchInputBox } from '../../../common/components/InputBox';
import QuestionTab from './QuestionTab';
import { routes } from '../../../../constants/routes';
import { generateQuery } from '../../../../utils/miscUtils';

const mapStateToProps = ({ BoardReducer }) => {
    return {
        postList: BoardReducer.postList,
    };
};

class SearchBox extends Component {
    constructor(props) {
        super(props);

        this.onClickSearch = this.onClickSearch.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onClickTab = this.onClickTab.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);

        const { history } = this.props;
        const topTag = history.query.top_tag || '';
        const search = history.query.search || '';

        this.state = {
            topTag,
            search,
        };
    }

    componentDidUpdate(prevProps, prevState) {
        const { history } = this.props;
        if (
            history.query.search !== prevProps.history.query.search ||
            history.query.top_tag !== prevProps.history.query.top_tag
        ) {
            const topTag = history.query.top_tag || '';
            const search = history.query.search || '';
            this.setState({
                topTag,
                search,
            });
        }
    }

    move(query) {
        this.props.history.push(
            `${routes.customer.question}${generateQuery({ ...query })}`
        );
    }

    onClickTab(category) {
        const tag = category === 'Best' ? '' : category;
        const params = {
            top_tag: tag,
            pageno: 1,
        };

        this.setState(
            {
                topTag: tag,
            },
            () => {
                this.move(
                    category === 'Best'
                        ? { ...params, is_noticed: true }
                        : params
                );
            }
        );
    }

    onClickSearch() {
        const { history } = this.props;
        const { search, topTag } = this.state;
        const params = {
            top_tag: topTag,
            search: search,
        };

        if (search === '') {
            delete params.search;
        }

        if (history.query.is_noticed) {
            params.is_noticed = true;
        }

        this.move(params);
    }

    onChange(e, value) {
        this.setState({
            search: value,
        });
    }

    onKeyDown(e) {
        this.onClickSearch();
    }

    renderResult() {
        const { history, postList } = this.props;
        if (!history.query.search) {
            return null;
        }

        return (
            <p className="search-result">
                <strong>{history.query.search}</strong> 에 대한 검색 결과가{' '}
                {postList.count}건 있습니다.
            </p>
        );
    }

    render() {
        const { search = '' } = this.state;
        const { history } = this.props;
        return (
            <div>
                <div className="search">
                    <SearchInputBox
                        type="text"
                        placeholder="서비스 관련한 궁금한 사항을 검색해 보세요."
                        title="검색어 입력"
                        value={search}
                        defaultValue={search}
                        onChange={this.onChange}
                        onSearchIconClick={this.onClickSearch}
                        onKeyDown={this.onKeyDown}
                    />
                </div>
                <QuestionTab history={history} onClickTab={this.onClickTab} />
                {this.renderResult()}
            </div>
        );
    }
}

export default connect(mapStateToProps)(SearchBox);
